import React, { useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/esm/Modal';

const StickyFooter = () => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <div className='sticky-footer fixed-bottom' id='stickyFooter'>
      <Container>
        <Row>
          <Col xs={12}>
            <Button size='sm' variant='primary' onClick={handleShowModal}>
              Kontakt
            </Button>
          </Col>
        </Row>
      </Container>

      <Modal className='modal-sticky-footer-contact' show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton closeLabel="Dialog schließen">
          <Modal.Title as="h2">Kontakt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='modal-text opening-days'>Montag - Freitag</p>
          <p className='modal-text opening-hours'>
            08:00 Uhr - 17:00 Uhr <br />
            sowie nach Vereinbarung
          </p>
          <p className='p telephone'>
            <span className='desc'>T:</span> +49 (0) 711 955 926 0
          </p>
          <p className='p fax'>
            <span className='desc'>F:</span> +49 (0) 711 955 926 99
          </p>
          <p className='p mail'>
            <span className='desc'>M:</span> info@ll-notare.de
          </p>
          <address>
            <span className='state'>Carré Bad Cannstatt</span> <br />
            <span className='street'>Kreuznacher Straße 68</span> <br />
            <span className='city'>70372 Stuttgart</span>
          </address>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-primary' onClick={handleCloseModal}>
            Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StickyFooter;